export const LYKA_PHONE_NUMBER = '1300 851 936'
export const LYKA_SUPPORT_EMAIL = 'info@lyka.com.au'
export const LYKA_TWITTER_HANDLE = 'lykapetfood'
export const LYKA_SUPPORT_HOURS_WEEKDAY: Readonly<[string, string]> = ['8:00', '18:00']
export const LYKA_SUPPORT_HOURS_WEEKEND: Readonly<[string, string]> = ['10:00', '18:00']
export const LYKA_TIMEZONE = 'Australia/Sydney' as const
export const LYKA_SUPPORT_HOURS_TIMEZONE = 'AET' as const

export const LYKA_FACEBOOK_URL = 'https://www.facebook.com/lykapetfood/'
export const LYKA_INSTAGRAM_URL = 'https://www.instagram.com/lykapetfood/'
export const LYKA_TIKTOK_URL = 'https://www.tiktok.com/@lykapetfood'
export const LYKA_LINKEDIN_URL = 'https://www.linkedin.com/company/lykapetfood'
export const LYKA_YOUTUBE_URL = 'https://www.youtube.com/@lykapetfood6476'

export const LYKA_BAB_PATH = '/get-started'
export const LYKA_LOGIN_PATH = '/membership/login'

export const DEFAULT_COUPON_CODE = 'FRESH30'
export const DEFAULT_COUPON_DISCOUNT = 30

export const TRUSTPILOT_RATING = 4.9
export const TRUSTPILOT_REVIEW_COUNT = 4_239

const GOOGLE_REVIEW_COUNT = 1_831
// https://www.productreview.com.au/listings/lyka-pet-food
const PRODUCT_REVIEW_COUNT = 979

export const TOTAL_REVIEW_COUNT = TRUSTPILOT_REVIEW_COUNT + GOOGLE_REVIEW_COUNT + PRODUCT_REVIEW_COUNT
export const ANIMALS_COUNT = 110_000
export const LYKA_TRUSTPILOT_URL = 'https://au.trustpilot.com/review/lyka.com.au'
export const MEALS_SERVED_COUNT = 65_000_000

export const MONEYBACK_GUARANTEE_URL =
  '/legal/privacy-and-terms#:~:text=warranty%20or%20condition.-,30%20day%20money%20back%20guarantee,-In%20this%2030'

export const SUPPORT_URL = 'https://help.lyka.com.au/hc/en-gb'
